<template>
  <div>
    <h3>{{ $t("SIMCARD_USAGE") }}</h3>

    <SimcardUsageFilter
      :all="allUsages"
      :count="allUsagesLength"
      :from="from"
      :order-by="sort"
      :order-type="sortType"
      :rows="usages"
      :to="to"
      :to-apply-filter="applyFilter"
      @filtered-items="filteredUsages"
      @reset-paging="page = 0"
      @reset-search="resetSearch"
      @set-from="setFrom"
      @set-to="setTo"
    />
    <div class="border-top mt-3 pb-3" />
    <AppLoader v-if="loadingData" />
    <div v-if="!usages.length && !loadingData">
      {{ $t("NO_SIMCARD_USAGE_TO_SHOW") }}
    </div>
    <div v-if="usages.length > 0" class="position-relative w-100">
      <div id="messages" class="table-responsive">
        <table class="table table-main table-hover">
          <thead>
            <tr>
              <th
                v-for="(column, index) in columns"
                :key="index"
                :class="{ isHidden: !column.visible }"
                :style="{ 'min-width': column.minWidth }"
              >
                <span v-if="column.sortable != true">
                  {{ $t(column.name) }}
                </span>
                <span v-else>
                  <div class="title" @click="sortUsagesBy(column.type)">
                    {{ $t(column.name) }}
                  </div>
                  <div v-if="sort == column.type" class="sorting">
                    <span v-if="sortType == 'desc'">▼</span>
                    <span v-if="sortType == 'asc'">▲</span>
                  </div>
                </span>
              </th>
              <th />
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, item_index) in usages.slice(
                this.page * Number(this.rowsPerPage),
                this.page * Number(this.rowsPerPage) + Number(this.rowsPerPage)
              )"
              :key="item_index"
            >
              <td
                v-for="(column, column_index) in columns"
                :key="column_index"
                :class="{
                  isHidden: !column.visible
                }"
                :style="{ width: column.minWidth }"
              >
                <!--                <span v-if="column.type == 'custServiceId'">-->
                <!--                  <span-->
                <!--                    class="gray-text-light"-->
                <!--                    style="display: block; word-wrap: break-word;"-->
                <!--                    >{{ item.custServiceId }}-->
                <!--                  </span>-->
                <!--                </span>-->
                <span v-if="column.type == 'dateTime'">
                  <span v-html="$filters.timestampToDateTime(item.dateTime)" />
                </span>
                <span v-else-if="column.type == 'incoming'">
                  <span v-if="item.incoming">
                    {{ $t("YES") }}
                  </span>
                  <span v-else>
                    {{ $t("NO") }}
                  </span>
                </span>
                <span v-else>
                  {{ item[column.type] }}
                </span>
              </td>
              <td>
                <span class="link-gray">
                  <span @click="showUsage({ usage: item })">{{ $t("zobrazit") }}</span>
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div v-if="usages.length > 0" class="custom-table__footer d-flex align-items-center justify-content-between">
      <div class="custom-table__footer__actions align-items-center" />

      <Paging
        :page="{
          currentPage: page,
          rowsPerPage: rowsPerPage,
          itemsTotalCount: usages.length,
          itemsCount: usages.length
        }"
        @next-page="page++"
        @page="page = $event"
        @prev-page="page--"
        @rows-per-page="rowsPerPage = $event"
      />
    </div>
    <div v-if="errorsToTranslate.length > 0">
      <ErrorModal :centered="true" :errors="errorsToTranslate" :opened="openedError" @close="openedError = false" />
    </div>
  </div>
</template>
<script>
import _ from "lodash"
import axios from "axios"
import Paging from "@/components/paging/paging.vue"
import ErrorModal from "@/components/confirmations/translatedErrors.vue"
import SimcardUsageFilter from "@/components/filters/simcard-usage-filter.vue"
import Loader from "@/components/loader.vue"

export default {
  components: {
    Paging,
    SimcardUsageFilter,
    AppLoader: Loader,
    ErrorModal
  },
  props: {
    items: Array,
    simcard: Object,
    reloadDM: Boolean
  },
  data() {
    return {
      sort: "dateTime",
      sortType: "desc",
      rowsPerPage: 20,
      page: 0,
      copyConfirmVisible: false,
      usages: [],
      from: "",
      to: "",
      allUsages: [],
      dateChanged: false,
      preloadedUsages: [],
      loadedComplete: false,
      applyFilter: false,
      loadingData: true,
      noMessages: false,
      tableWidth: 0,
      errorsToTranslate: [],
      openedError: false,
      columns: [
        {
          type: "custServiceId",
          name: "sluzba",
          sortable: false,
          visible: true,
          minWidth: "250px",
          order: 1
        },
        {
          type: "dateTime",
          name: "datum",
          sortable: true,
          minWidth: "250px",
          visible: true,
          order: 2
        },
        {
          type: "amount",
          name: "AMOUNT",
          sortable: false,
          visible: true,
          minWidth: "80px",
          order: 3
        },
        {
          type: "iccid",
          name: "ICCID",
          sortable: false,
          visible: true,
          minWidth: "250px",
          order: 4
        },
        {
          type: "imsi",
          name: "IMSI",
          sortable: false,
          visible: true,
          minWidth: "250px",
          order: 5
        },
        {
          type: "serviceType",
          name: "SERVICE_TYPE",
          sortable: false,
          visible: true,
          minWidth: "80px",
          order: 6
        },
        {
          type: "incoming",
          name: "INCOMING",
          sortable: false,
          visible: true,
          minWidth: "80px",
          order: 7
        }
      ],
      tableColumnsDefault: {
        custServiceId: {
          show: true,
          order: 1,
          title: "custServiceId"
        },
        dateTime: {
          show: true,
          order: 2,
          title: "dateTime"
        },
        amount: {
          show: true,
          order: 3,
          title: "amount"
        },
        iccid: {
          show: true,
          order: 4,
          title: "iccid"
        },
        imsi: {
          show: true,
          order: 5,
          title: "imsi"
        }
      },
      showSidebarTableColumnOrder: false,
      tableColumns: {},
      showShadow: false
    }
  },
  computed: {
    allUsagesLength() {
      return this.usages.length
    },
    dateChange() {
      const { to, from } = this
      return {
        from,
        to
      }
    }
  },
  watch: {
    dateChange: {
      handler: function (val) {
        if (val.from != "1970-01-01T00:00:00.000Z") {
          this.setApplyFilter()
        }
      },
      deep: true
    },
    loadingData: {
      handler() {
        this.$nextTick(() => {
          this.updateResponsiveTable()
        })
      }
    },
    rowsPerPage() {
      this.page = 0
      localStorage.rowsPerPage = this.rowsPerPage
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.updateResponsiveTable)
      window.addEventListener("click", this.updateResponsiveTable)
    })
    if (localStorage.rowsPerPage) {
      var rows1 = localStorage.rowsPerPage
      this.rowsPerPage = rows1
    } else {
      localStorage.rowsPerPage = this.rowsPerPage
    }
    this.updateResponsiveTable()
    this.setDateRange()
  },
  methods: {
    updateResponsiveTable() {
      this.$updateResponsiveTable(this, "messages")
    },
    resetSearch() {
      let now = new Date()
      const dateTo = now
      const dateFrom = new Date(dateTo - 1 * 24 * 60 * 60 * 1000)
      this.from = dateFrom.toISOString()
      this.to = now.toISOString()
    },
    async setApplyFilter() {
      this.page = 0
      this.applyFilter = false
      let messagesLoaded = await this.loadMessages()
      if (messagesLoaded) {
        this.applyFilter = true
        return true
      }
    },
    setDateRange() {
      let now = new Date()
      now.setHours(0, 0, 0, 0)
      const dateTo = now
      const dateFrom = new Date(dateTo - 31 * 24 * 60 * 60 * 1000)
      this.from = dateFrom.toISOString()
      this.to = now.toISOString()
    },
    async loadMessages() {
      this.loadingData = true
      this.usages = []
      this.allUsages = []
      this.loadedComplete = false
      return axios
        .get(
          process.env.VUE_APP_API +
            "/simcards/service/" +
            this.simcard.custServiceId +
            "/" +
            this.simcard.iccid +
            "/usage?from=" +
            this.from +
            "&to=" +
            this.to +
            "&limit=1",
          {}
        )
        .then((result) => {
          if (result.data.metadata.count > 0) {
            let steps = Math.ceil(result.data.metadata.count / 1000)
            let promises = []
            for (let i = 0; i < steps; i++) {
              promises.push(
                axios
                  .get(
                    process.env.VUE_APP_API +
                      "/simcards/service/" +
                      this.simcard.custServiceId +
                      "/" +
                      this.simcard.iccid +
                      "/usage?from=" +
                      this.from +
                      "&to=" +
                      this.to +
                      "&offset=" +
                      i * 1000 +
                      "&limit=1000",
                    {}
                  )
                  .then((result) => {
                    let sorted = _.orderBy(result.data.data, "dateTime", "desc")
                    this.allUsages = sorted
                    this.usages = sorted
                    this.loadingData = false
                    this.loadedComplete = true
                  })
                  .catch((error) => {
                    let message = error.data.errors[0]
                    error.data.errors = []
                    error.data.errors.push({
                      message: message
                    })
                    this.loadingData = false
                    this.errorsToTranslate.push(error.data)
                  })
              )
            }
            return Promise.all(promises).then(() => {
              this.$nextTick(() => {
                this.updateResponsiveTable()
              })
              return true
            })
          } else {
            this.usages = []
            this.allUsages = []
            this.loadingData = false
            this.loadedComplete = true
            return true
          }
        })
        .catch(() => {})
    },
    filteredUsages(usages) {
      if (usages != undefined) {
        this.usages = usages
      }
    },
    sortUsagesBy(sortBy) {
      let sorted
      this.sort = sortBy
      if (this.sortType == "asc") {
        sorted = _.orderBy(this.usages, `${sortBy}`, "desc")
        this.sortType = "desc"
      } else {
        sorted = _.orderBy(this.usages, `${sortBy}`, "asc")
        this.sortType = "asc"
      }
      this.dateChanged = false
      this.usages = sorted
    },
    copyToClipboard(text) {
      this.copyConfirmVisible = true
      var input = document.createElement("textarea")
      input.innerHTML = text
      document.body.appendChild(input)
      input.select()
      var result = document.execCommand("copy")
      document.body.removeChild(input)
      return result
    },
    setTo(to) {
      let t = new Date(Date.parse(to))
      t.setHours(23, 59, 59, 999)
      this.to = t.toISOString()
    },
    setFrom(from) {
      let f = new Date(Date.parse(from))
      f.setHours(0, 0, 0, 0)
      this.from = f.toISOString()
    },
    showUsage(message) {
      this.$emit("showUsage", message)
    },
    closeSidebarTableColumnOrder() {
      this.tableColumns = this.getTableColumns()
      this.showSidebarTableColumnOrder = false
      this.$nextTick(() => {
        this.updateResponsiveTable()
      })
    },
    getTableColumns() {
      const localStorageItemsJSON = localStorage.getItem(this.columnsTypeName)
      if (!localStorageItemsJSON) {
        return this.tableColumnsDefault
      }

      const localStorageItems = JSON.parse(localStorageItemsJSON)

      if (Object.keys(localStorageItems).length === 0) {
        return this.tableColumnsDefault
      }
      return localStorageItems
    }
  }
}
</script>

<style lang="scss" scoped></style>
